import { Modal, Button, Input } from "antd"
import styled from "styled-components"
import { useEffect, useState } from "react"
import {Radio} from 'antd'
import { auth,db } from "../Config"
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore"
import { async } from "@firebase/util"
const UserField = styled.div`
    width:60vw;
    min-height:80vh;
    border-radius:20px;
    margin-top:15vh;
    margin-left:18vw;
    border:2px solid tomato;
    display:flex;
    @media (max-width:767px){
        flex-direction:column;
        width:90vw;
        margin-left:5vw;
        margin-bottom:5vh;
    }
`
const UserInfo = styled.div`
    width:50%;
    height:100%;
    display:flex;
    flex-direction:column;
    padding:2vh 2vw;
    @media (max-width:767px){
        width:100%; 
    }
    input{
        margin-bottom:2vh;
    }
`
const PayMethod = styled.div`
    width:50%;
    height:100%;
    flex-direction:column;
    padding:2vh 2vw;
    @media (max-width:767px){
        width:100%; 
    }
    .confirm-btn{
        color:white;
        background-color:tomato;
        border-color:tomato;
        border-radius:5px;
        margin-top:3vh
    }
`
export default function User(){
    const [user,setUser] = useState()
    useEffect(()=>{
        const docRef = doc(db,'users',auth.currentUser.uid)
        getDoc(docRef).then((doc)=>{
            setUser(doc.data())
        })
    },[])
    const [value, setValue] = useState(1);
    const [name,setName] = useState('')
    const [phone,setPhone] = useState('')
    const [city,setCity] = useState('')
    const [district,setDistrict] = useState('')
    const [wards,setWards] = useState('')
    const [address,setAddress] = useState('')
    const [fullInfo,setFullInfo] = useState(false)
    useEffect(()=>{ 
        const getUser = () =>{
            if(user){
                setValue(user.payMethod)
                setName(user.name)
                setPhone(user.phone)
                setCity(user.city)
                setDistrict(user.district)
                setWards(user.wards)
                setAddress(user.address)
                setFullInfo(user.fullInfo)
            }
        }
        getUser()
    },[user])
    const onChange = e => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };
    const handleSubmit = () =>{
        if(name===''){
            error('Tên không được bỏ trống')
        } else if(phone===''){
            error('Sđt không được bỏ trống')
        } else if(city===''){
            error('Tên thành phố không được bỏ trống')
        } else if(district===''){
            error('Tên quận huyện không được bỏ trống')
        } else if(wards===''){
            error('Tên xã phường không được bỏ trống')
        } else if(address===''){
            error('Địa chỉ không được bỏ trống')
        }else{
            const docRef = doc(db,'users',auth.currentUser.uid)
            updateDoc(docRef,{
            name:name,
            phone:phone,
            city:city,
            district:district,
            wards:wards,
            address:address,
            payMethod:value,
            fullInfo:true,
            })
            success()
        }
    }
    function error(err) {
        Modal.error({
          title: 'Lỗi',
          content:err,
        });
    }
    function success() {
        Modal.success({
          content: 'Lưu thành công!',
        });
      }
    if(user){
        return(
        <UserField>
            <UserInfo>
                <p>Họ Tên</p>
                <Input placeholder="Họ Tên" defaultValue={user.name} onChange={e=>setName(e.target.value)}/>
                <p>Số Điện Thoại</p>
                <Input placeholder="Sđt" defaultValue={user.phone} onChange={e=>setPhone(e.target.value)}/>
                <p>Tỉnh Thành</p>
                <Input placeholder="Tỉnh Thành" defaultValue={user.city} onChange={e=>setCity(e.target.value)}/>
                <p>Quận Huyện</p>
                <Input placeholder="Quận Huyện" defaultValue={user.district} onChange={e=>setDistrict(e.target.value)}/>
                <p>Xã Phường</p>
                <Input placeholder="Xã Phường" defaultValue={user.wards} onChange={e=>setWards(e.target.value)}/>
                <p>Địa Chỉ</p>
                <Input placeholder="Địa Chỉ" defaultValue={user.address} onChange={e=>setAddress(e.target.value)}/>
            </UserInfo>
            <PayMethod>
                <h3>Phương thức thanh toán</h3>
                <Radio.Group onChange={onChange} defaultValue={value} style={{display:"flex",flexDirection:'column'}}>
                    <Radio value={1} style={{margin:'1vh 0'}}>Thanh Toán Khi Nhận Hàng</Radio>
                    <Radio value={2} style={{margin:'1vh 0'}}>Thanh toán bằng ATM nội địa (Internet Banking)</Radio>
                    <Radio value={3} style={{margin:'1vh 0'}}>Thanh toán bằng Credit/Debit Card (VISA, MASTER, JCB, AMEX)</Radio>
                    <Radio value={4} style={{margin:'1vh 0'}}>Chuyển khoản ngân hàng</Radio>
                </Radio.Group>
                <Button className="confirm-btn" onClick={handleSubmit}>Xác Nhận</Button>
            </PayMethod>
        </UserField>
    )
    }
    else{
        return(
            <></>
        )
    }
}